import { Component, Input, ViewEncapsulation, ViewChildren, QueryList, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { element } from 'protractor';

import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
//import { ToasterModule, ToasterService, ToasterConfig } from 'angular2-toaster';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl, FormGroupName} from '@angular/forms';
import { ValidationFormsService } from './validation-forms.service';
import { ValidatorFn, ValidationErrors } from '@angular/forms';
import { ToasterComponent, ToasterPosition } from '@coreui/angular';
import { AppToastComponent as ToastComp } from '../../../services/shared-service/toast-simple/toast.component'
import { HttpService } from '../../../services/http-service/http.service'
import { ValidationService } from '../../../services/validation-service/validation.service';
import { ModalDirective } from 'ngx-bootstrap/modal';

import { ToastrService } from 'ngx-toastr';
import { LocalInterfaceService } from '../../../services/local-inteface-service/local-interface.service';
import { StorageService } from '../../../services/storege-service/storage.service';
import * as moment from 'moment';
import { ToolService } from '../../../services/tool/tool.service';

@Component({
  //selector: 'app-toasters',
  templateUrl: 'basic-forms.component.html',
  styleUrls: ["../../../../../node_modules/ngx-bootstrap/datepicker/bs-datepicker.css",],
  //encapsulation: ViewEncapsulation.None,
  providers: [ ValidationFormsService ]
})


export class BasicFormsComponent {
  minDate = new Date(2017, 5, 10);
  maxDate = new Date(2022, 9, 15);

  bsValue: Date = new Date();

  // Timepicker

  public isEnabled: boolean = true;


  public mfData? : object = {};
  public courts?;
  public users?;
  public types?;
  public coaches?;
  public facilities?;
  public filteredFacilities?;
  isUpdate: boolean = false;
  dbFunction?: string;
  facilityId: string;
  courtId: string;
  coachId: string;
  coachPackageId: string;
  nameEn: string;
  nameAr: string;
  descriptionEn: string;
  descriptionAr: string;
  typeEn: string;
  typeAr: string;
  countryCode: string;
  mobile: string;
  sort: string;
  startDate: string;
  endDate: string;
  noOfSessions: string;
  duration: string;
  price: string;
  ccy: string;
  rate: string;
  age: string;
  gender: string;
  percentageOnCustomer: string;
  percentageOnCoach: string;
  percentageOnFacility: string;
  forFacility: string;
  combinedPrice: string;
  taxPercentage: string;
  facilityCcy: string;

  uploadedImage: File;
  base64Image: string;
  profileImage: string;
  status: string;
  public isLoading = false;
  genders:Array<{nameEn: string}> = [];
  ages:Array<{nameEn: string}> = [];

  isError: boolean = false;

  simpleForm: FormGroup;
  submitted = false;
  formErrors: any;

  public responseData?;
  public dbActiveData? = Array();
  public dbActiveFacilitiesData? = Array();

  //private toasterService: ToasterService;
  //public toasterconfig: ToasterConfig = new ToasterConfig({tapToDismiss: true, timeout: 5000});
  
  @ViewChild(ToastComp) toastComp: ToastComp;
  @ViewChild('resetModal', {static: false}) public resetModal: ModalDirective;

  public paddingStyle: Object = { 'padding-right': '20px'};


  constructor(
    private router: Router, 
    private http: HttpClient, 
    public route: ActivatedRoute,
    private fb: FormBuilder,
    public vf: ValidationFormsService, 
    public httpService: HttpService,
    private toastr: ToastrService,
    private localInterfaceSrv: LocalInterfaceService,
    private validationSrv : ValidationService,
    private storageSrv : StorageService,
    public toolService: ToolService,
    ) {
    //if (localStorage.getItem('currentUser') === null) {this.router.navigateByUrl('/login');}
    if (localStorage.getItem('lang') === "ar") {
      //this.toasterconfig = new ToasterConfig({tapToDismiss: true, timeout: 5000, positionClass: 'toast-top-left'});
    }
    //this.toasterService = toasterService;
    this.formErrors = this.vf.errorMessages;
    this.facilityCcy = this.storageSrv.getFacilityCcy();

    if(this.router.getCurrentNavigation().extras.state?.createData == null)
    {
      this.isUpdate = true;
      this.dbFunction = 'updateUsersTable';
      this.mfData = this.router.getCurrentNavigation().extras.state?.data;
      this.coachPackageId = this.mfData['id'];
      this.coachId = this.mfData['coachId'];
      this.facilityId = this.mfData['facilityIds']?.split(',');
      //this.courtId = this.mfData['courtIds']?.split(',');
      this.nameEn = this.mfData['nameEn'];
      this.nameAr = this.mfData['nameAr'];
      this.descriptionEn = this.mfData['descriptionEn'];
      this.descriptionAr = this.mfData['descriptionAr'];
      this.typeEn = this.mfData['typeEn'];
      this.typeAr = this.mfData['typeAr'];
      this.countryCode = this.mfData['countryCode'];
      this.mobile = this.mfData['mobile'];
      this.sort = this.mfData['sort'];
      this.noOfSessions = this.mfData['noOfSessions'];
      this.duration = this.mfData['duration'];
      this.price = this.mfData['price'];
      this.ccy = this.mfData['ccy'];
      this.startDate = this.mfData['startDate'] != null ? new Date(this.mfData['startDate'].replace(/-/g, "/")) : this.mfData['startDate'];
      this.endDate = this.mfData['endDate'] != null ? new Date(this.mfData['endDate'].replace(/-/g, "/")) : this.mfData['endDate'];
      this.age = this.mfData['age'];
      this.gender = this.mfData['gender'];
      this.rate = this.mfData['rate'];
      this.percentageOnCustomer = this.mfData['percentageOnCustomer'];
      this.percentageOnCoach = this.mfData['percentageOnCoach'];
      this.percentageOnFacility = this.mfData['percentageOnFacility'];
      this.forFacility = this.mfData['forFacility'];
      this.combinedPrice = this.mfData['combinedPrice'];
      this.taxPercentage = this.mfData['taxPercentage'];
      this.status = this.mfData['status'];
    }
    else
    {
      this.dbFunction = '/addBooking';
      this.coachPackageId = '';
      this.coachId = '';
      this.facilityId = '';
      //this.courtId = '';
      this.mobile = '';
      this.countryCode = '';
      this.nameEn = '';
      this.nameAr = '';
      this.descriptionEn = '';
      this.descriptionAr = '';
      this.typeEn = '';
      this.typeAr = '';
      this.sort = '';
      this.noOfSessions = '';
      this.duration = '';
      this.price = '';
      this.ccy = '';
      this.rate = '';
      this.startDate = '';
      this.endDate = '';
      this.age = '';
      this.gender = '';
      this.percentageOnCustomer = '';
      this.percentageOnCoach = '';
      this.percentageOnFacility = '';
      this.forFacility = '';
      this.combinedPrice = '';
      this.taxPercentage = '';
      this.status = '';
    }
    this.loadGender();
    this.loadAge();
    this.simpleForm = this.fb.group({});
    // this.loadUserTypes();
    // this.createForm();
  }

  ngOnInit(): void {
    this.validationSrv.validateAcess()
    .then(async () => {
      this.isLoading = true;
      this.route.queryParams.subscribe(async params => {
        await this.loadActiveFacilities();
        await this.loadCourts(this.facilityId);
        await this.loadCoaches();
        await this.createForm();
      });
    });
  }

  isCollapsed: boolean = false;
  iconCollapse: string = 'icon-arrow-up';

  @Input() message : string;
  messages: string[] = [];
  updatedData = this.mfData;

  createForm() {
    this.simpleForm = this.fb.group({
      coachPackageId: [this.coachPackageId, [Validators.required]],
      coachId: [this.coachId, [Validators.required]],
      facilityId: [this.facilityId, [Validators.required]],
      //courtId: [this.courtId, [Validators.required]],
      mobile: [this.mobile, [Validators.required]],
      countryCode: [this.countryCode, [Validators.required]],
      nameEn: [this.nameEn, [Validators.required]],
      nameAr: [this.nameAr],
      descriptionEn: [this.descriptionEn],
      descriptionAr: [this.descriptionAr],
      typeEn: [this.typeEn],
      typeAr: [this.typeAr],
      noOfSessions: [this.noOfSessions],
      duration: [this.duration],
      price: [this.price],
      ccy: [this.ccy],
      rate: [this.rate],
      startDate: [this.startDate],
      endDate: [this.endDate],
      gender: [this.gender],
      age: [this.age],
      percentageOnCustomer: [this.percentageOnCustomer],
      percentageOnCoach: [this.percentageOnCoach],
      percentageOnFacility: [this.percentageOnFacility],
      forFacility: [this.forFacility],
      combinedPrice: [this.combinedPrice],
      taxPercentage: [this.taxPercentage],
      sort: [this.sort],
      status: [this.status],
    }, { });
  }
  get f() { return this.simpleForm.controls; }


  async showSuccess(msg) {

    await this.toastr.success(msg, 'Success');

    if (this.isUpdate && !this.isError)
    {
      this.delay(2000).then(any=>{
        this.router.navigate(['../'], {relativeTo: this.route}).then(() => {
          //window.location.reload();
        });;
      });  
    }
    else if (!this.isUpdate && this.isError == false)
    {
      this.delay(2000).then(any=>{
        this.router.navigate(['../'], {relativeTo: this.route}).then(() => {
          //window.location.reload();
        });;
      });  
    }
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.simpleForm.controls;
    for (const name in controls) {
        if (controls[name].invalid) {
            invalid.push(name);
        }
    }
    return invalid;
  }

  uploadFile(event) {
    let files = event.target.files;
    const reader = new FileReader();
    if (files.length > 0) {
      this.uploadedImage = files[0]; // You will see the file
      reader.readAsDataURL(this.uploadedImage);
      reader.onload = (_event) => { 
        this.profileImage = reader.result.toString(); 
    }
    }
  }

  saveCoachPackage = () => {

  if (this.uploadedImage != null)
  {
    this.base64Image = this.profileImage;
    this.simpleForm.controls['officialPicUrl'].setValue(this.uploadedImage.name);
  }


  return new Promise<any>(async (resolve, reject) => {
    this.isLoading = true;
    let formattedStartDate = (moment(new Date(this.f['startDate'].value))).format('YYYY-MM-DD');
    let formattedEndDate = (moment(new Date(this.f['endDate'].value))).format('YYYY-MM-DD');
    const fields = {
      coachPackageId: this.mfData['id'],
      coachId: this.f['coachId'].value,
      facilityIds: this.f['facilityId'].value,
      //courtId: this.f['courtId'].value,
      nameEn: this.f['nameEn'].value,
      nameAr: this.f['nameAr'].value,
      descriptionEn: this.f['descriptionEn'].value,
      descriptionAr: this.f['descriptionAr'].value,
      typeEn: this.f['typeEn'].value,
      typeAr: this.f['typeAr'].value,
      noOfSessions: this.f['noOfSessions'].value,
      duration: this.f['duration'].value,
      price: this.f['price'].value,
      ccy: this.f['ccy'].value,
      rate: this.f['rate'].value,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      gender: this.f['gender'].value,
      age: this.f['age'].value,
      percentageOnCustomer: this.f['percentageOnCustomer'].value,
      percentageOnCoach: this.f['percentageOnCoach'].value,
      percentageOnFacility: this.f['percentageOnFacility'].value,
      forFacility: this.f['forFacility'].value,
      combinedPrice: this.f['combinedPrice'].value,
      taxPercentage: this.f['taxPercentage'].value,
      sort: this.f['sort'].value,
      status: this.f['status'].value,
    };
    if (this.isUpdate) 
    {
      this.localInterfaceSrv.updateCoachPackage(fields)
      .then(async res => {
        resolve(res);
        this.showSuccess('Package Updated');
      })
      .catch(err => { 
        reject(err); 
        this.toastr.error(err.description, "Error");
      })
      .finally(() => this.isLoading = false);
    } 
    else 
    {
      this.localInterfaceSrv.addCoachPackage(fields)
      .then(async res => {
        resolve(res);
        this.showSuccess('Package Added');
      })
      .catch(err => { 
        reject(err); 
        this.toastr.error(err.description, "Error");
      })
      .finally(() => this.isLoading = false);
    }
  });
  }

  async delay(ms: number) {
    //await new Promise(resolve => setTimeout(()=>resolve(), ms)).then(()=>this.toolService.showConsoleLog("fired"));
  }

  collapsed(event: any): void {
    // this.toolService.showConsoleLog(event);
  }

  updateData(name: string): void {
    this.updateData['nameEn'] = name;
  }
 

  expanded(event: any): void {
    // this.toolService.showConsoleLog(event);
  }

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
    this.iconCollapse = this.isCollapsed ? 'icon-arrow-down' : 'icon-arrow-up';
  }

  loadCourts = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getCourts(this.facilityId)
      .then(res => {
        this.responseData = Object.values(res);
        this.responseData[0].forEach(item => {
          if (item.status=='A')
          {
            const newObj = item;
            this.dbActiveData.push(newObj);
          }
        });
        this.courts = this.dbActiveData;
        this.courts.offers = res.offers;
        this.courts.content = this.dbActiveData;
        //this.courts = res;
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
        this.toastr.error(err.desc, "Error");
      })
      .finally();
    });
  }
  loadActiveFacilities = () => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getActiveFacilitiesBranches()
      .then(res => {
        this.facilities = res.content;
        this.filteredFacilities = res.content;
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
        this.toastr.error(err.description, "Error");
      })
      .finally(() => {this.isLoading = false;});
    });
  }

  loadCoaches = () => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getCoaches()
      .then(res => {
        this.coaches = res.content;
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
        this.toastr.error(err.description, "Error");
      })
      .finally(() => {this.isLoading=false});
    });
  }

  filterFacilitiesByCoach = (coachId) => {
    // coachId = this.f['coachId'].value;
    // var selectedFacilityIds = '';
    // this.coaches.forEach(coach => {
    //   if (coach.id==coachId)
    //   {
    //     this.toolService.showConsoleLog("123"); 
    //     selectedFacilityIds = coach.facilityIds;
    //   }
    // });
    // var selectedCoachFacilities = selectedFacilityIds?.split(',');
    // this.filteredFacilities = this.facilities;
    // var filterdResult = Array();
    // this.filteredFacilities = Object.values(this.filteredFacilities);
    // this.filteredFacilities.forEach(item => {
    //   if (selectedCoachFacilities.indexOf(item.facilityId) !== -1)
    //   {
    //     const newObj = item;
    //     filterdResult.push(newObj);
    //   }
    // });
    // this.toolService.showConsoleLog(filterdResult);
    // //this.facilityId = filterdResult.toString();
    // this.simpleForm.patchValue({facilityId: filterdResult});

  }
  filterCourts = (id) => {
    // this.loadCourtsByFacility(id);
  }

  loadCourtsByFacility = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      //this.isLoading = true;
      this.localInterfaceSrv.getCourts(facilityId)
      .then(res => {
        this.courts.content = res.content;
        //this.courts = res;
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
        this.toastr.error(err.desc, "Error");
      })
      .finally();
    });
  }

  loadAge = () => {
    this.ages.push({
      nameEn: '6-10'
    });
    this.ages.push({
      nameEn: '11-14'
    });
    this.ages.push({
      nameEn: '15+'
    });
  }
  loadGender = () => {
    this.isLoading = true;
    this.genders.push({
      nameEn: 'Men'
    });
    this.genders.push({
      nameEn: 'Women'
    });
    this.genders.push({
      nameEn: 'Mix'
    });
  }

}
